/**
 * CFSN-585 A/B: hero banner video playback control.
 * - Pauses videos while scrolled out of the viewport, resumes on return.
 * - Catches Flickity wrapAround clones / breakpoint re-inits (which insert
 *   video clones after this script runs) via a MutationObserver on the track.
 * - Respects prefers-reduced-motion: leaves only the poster image, no playback.
 * The `autoplay` attribute remains the no-JS fallback.
 */
(function () {
  var SELECTOR = '.banner-slider__media-video';
  if (!document.querySelector(SELECTOR)) return;

  // Reduced motion: keep the poster image, never play.
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.querySelectorAll(SELECTOR).forEach(function (video) {
      video.removeAttribute('autoplay');
      video.pause();
    });
    return;
  }

  if (!('IntersectionObserver' in window)) return;

  var observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        var video = entry.target;
        if (entry.isIntersecting) {
          var playPromise = video.play();
          if (playPromise && playPromise.catch) playPromise.catch(function () {});
        } else {
          video.pause();
        }
      });
    },
    { threshold: 0.25 }
  );

  // WeakSet membership is not copied by cloneNode, so Flickity clones always
  // register as new and get observed (re-observing the same node is a no-op).
  var seen = new WeakSet();
  function observeAll() {
    document.querySelectorAll(SELECTOR).forEach(function (video) {
      if (seen.has(video)) return;
      seen.add(video);
      observer.observe(video);
    });
  }

  observeAll();

  if ('MutationObserver' in window) {
    document.querySelectorAll('.banner-slider__track').forEach(function (track) {
      new MutationObserver(observeAll).observe(track, { childList: true, subtree: true });
    });
  }
})();
